import { Component, OnDestroy, OnInit } from '@angular/core';

import { Observable, Subscription } from 'rxjs';

import { AuthUser }    from '@models/user/auth-user';
import { LayoutTypes } from '@models/layout/layout-types.enum';

import { UserService }   from '@services/user.service';
import { LayoutService } from '@layout/layout.service';


@Component({
  selector:    'red-layout-bare',
  templateUrl: './layout-bare.component.html',
  styleUrls:   [ './layout-bare.component.scss' ]
})
export class LayoutBareComponent implements OnInit, OnDestroy {

  private layoutSubscription: Subscription;

  public user$: Observable<AuthUser>;

  constructor(
    private userService: UserService,
    private layoutService: LayoutService,
  ) {
    this.user$ = this.userService.getActiveUser();
  }

  public ngOnInit(): void {
    this.user$.subscribe((_user: AuthUser) => {
      this.layoutService.setActiveLayout(LayoutTypes.BARE);
      this.layoutSubscription = this.layoutService.activeLayout$.subscribe();
    });
  }

  ngOnDestroy() {
    this.layoutSubscription.unsubscribe();
  }
}
